(ns teamoesterreich.admin-mode.questionnaire.questionnaire-question-detail-form
  (:require [clojure.string :as str]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.view-state :as vstate]
            [goog.json :as json]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.ui-helper.image-drop-upload :as image-drop-upload]
            [teamoesterreich.admin-mode.data.questionnaire :as d-questionnaire]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.arrow-upward :refer [arrow-upward]]
            [reagent-material-ui.icons.arrow-downward :refer [arrow-downward]]
            [reagent-material-ui.icons.insert-photo :refer [insert-photo]]
            [reagent-material-ui.icons.radio-button-checked-two-tone :refer [radio-button-checked-two-tone]]
            [reagent-material-ui.icons.check-box-outline-blank-two-tone :refer [check-box-outline-blank-two-tone]]
            [reagent-material-ui.icons.confirmation-number :refer [confirmation-number]]
            [reagent-material-ui.icons.text-fields :refer [text-fields]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]))




(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))
(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))

(defn get-image [!question reload-fn]
  [:div [(image-drop-upload/get-it (:questionnaireQuestion-imageUri @!question)
                                   (fn [new-url]
                                     (d-questionnaire/>question-save (:questionnaireQuestion-uuid @!question) {:questionnaireQuestion-imageUri new-url} reload-fn))
                                   {:width 400 :max-height 400})]
   [mui/card-actions [mui/button {
                                  :startIcon (r/as-element [delete-forever])
                                  :onClick   #(d-questionnaire/>question-save (:questionnaireQuestion-uuid @!question) {:questionnaireQuestion-imageUri ""} reload-fn)
                                  } "Bild Löschen"]]])

(defn get-base [!question disabled reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!question key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!question key))))
            has-changes? (or
                           (changed? :questionnaireQuestion-question)
                           (changed? :questionnaireQuestion-questionDynamic)
                           (changed? :questionnaireQuestion-description)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            ]
        [mui/card
         (log/debug "rerender form " @!question @!data)
         [mui/card-header {:title "Frage Details"}]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    1
            :style      {:margin "0 0 0 0"}
            }

           [mui/grid
            {:container false :item true
             :md        12
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :questionnaireQuestion-question) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :rowsMax      5
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:questionnaireQuestion-question @!question))
                             :onChange     (fn [e] (change-fn :questionnaireQuestion-question (h/event-value e)))
                             :label        "Frage"}]
            ]

           [mui/grid
            {:container false :item true
             :md        12
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :questionnaireQuestion-questionDynamic) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (or (:questionnaireQuestion-questionDynamic @!question) (:questionnaireQuestion-question @!question)))
                             :onChange     (fn [e] (change-fn :questionnaireQuestion-questionDynamic (h/event-value e)))
                             :label        "Frage mit Formel"}]
            ]

           [mui/grid
            {:container false :item true
             :md        12
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :questionnaireQuestion-description) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :multiline    true
                             :minRows      2
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (or (:questionnaireQuestion-description @!question)))
                             :onChange     (fn [e] (change-fn :questionnaireQuestion-description (h/event-value e)))
                             :label        "Frage Beschreibung"}]
            ]

           ]
          [mui/card-actions
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   #(reset! !edit-mode false)
                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (not has-changes?)
                          :onClick   (fn []
                                       (d-questionnaire/>question-save (:questionnaireQuestion-uuid @!question) @!data reload-fn))
                          } "Speichern"])

           ]
          ]

         ]))))

(defn get-info [!question disabled reload-fn]

  (let [has-edit-right false
        save-fn (fn [text] (d-questionnaire/>question-save (:questionnaireQuestion-uuid @!question) {:questionnaireQuestion-longDescription text} reload-fn))]
    [:div
     [mui/card-header {:title "Info"}]
     [:span {:style {:paddingLeft "15px"}} "Wenn hier nichts steht wird der Info-Knopf in den Apps nicht angezeigt!"]
     (if disabled
       [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!question :questionnaireQuestion-longDescription) ""))}
              :className               "editor-preview-widget"
              :style                   {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]
       [(edit-md-card/get-it (get @!question :questionnaireQuestion-longDescription) save-fn (str backend/BASE_URL "/media-upload")
                             ""
                             )]
       )]
    ))

(defn get-header [!question disabled reload-fn]
  [mui/card-header {:onClick reload-fn
                    :title   (str "Frage " (:questionnaireQuestion-index @!question))}])

(defn get-answerOption-by-index [questions index reload-fn]
  (second (first (filter #(= index (:questionnaireAnswerOption-index (second %))) questions))))

(defn get-answerOption-max-index [question]
  (reduce (fn [c v]
            (max c (if (:questionnaireAnswerOption-active v) (:questionnaireAnswerOption-index v) 0)))
          0
          (:questionnaireQuestion-AnswerOption question)))

(defn >swap-answerOption-index-upwards [uuid index questions reload-fn]
  (d-questionnaire/>answerOption-save-index uuid (dec index) reload-fn)
  (when-let [uuid (:questionnaireAnswerOption-uuid (get-answerOption-by-index questions (dec index) reload-fn))]
    (d-questionnaire/>answerOption-save-index uuid index reload-fn)))

(defn >swap-answerOption-index-downwards [uuid index questions reload-fn]
  (d-questionnaire/>answerOption-save-index uuid (inc index) reload-fn)
  (when-let [uuid (:questionnaireAnswerOption-uuid (get-answerOption-by-index questions (inc index) reload-fn))]
    (d-questionnaire/>answerOption-save-index uuid index reload-fn)))

(defn answer-card [answerOption answerOptions reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !data (r/cursor !st [:data])
        ]
    (fn []
      (let [index (:questionnaireAnswerOption-index answerOption)
            option-uuid (:questionnaireAnswerOption-uuid answerOption)
            option-icon (case (:questionnaireAnswerOption-type answerOption)
                          "image" [insert-photo]
                          "radio" [radio-button-checked-two-tone]
                          "checkbox" [check-box-outline-blank-two-tone]
                          "decimal" [confirmation-number]
                          "number" [confirmation-number]
                          "numeric" [confirmation-number]
                          "text" [text-fields])
            changed? (fn [key]
                       ;(log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get answerOption key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get answerOption key))))
            has-changes? (or
                           (changed? :questionnaireAnswerOption-points)
                           (changed? :questionnaireAnswerOption-type)
                           (changed? :questionnaireAnswerOption-text)
                           (changed? :questionnaireAnswerOption-hint)
                           (changed? :questionnaireAnswerOption-motiv)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))]
        (if-not @!edit-mode
          [mui/card {:style {:marginBottom "5px"}}
           [mui/card-header {:subheader (str "Antwortoption " (:questionnaireAnswerOption-points answerOption) " Punkte")}]
           [mui/card-content option-icon [:span {:style {:display "inline_block" :verticalAlign "center" :fontSize "18px" :marginLeft "10px"}} (:questionnaireAnswerOption-text answerOption)]
            ]
           [mui/card-actions
            [mui/button {:startIcon (r/as-element [edit])
                         :onClick   #(reset! !edit-mode true)} "Bearbeiten"]
            [mui/button {:startIcon (r/as-element [delete-forever])
                         :onClick   (fn []
                                      (d-questionnaire/>answerOption-save option-uuid {:questionnaireAnswerOption-active false} reload-fn)
                                      (reset! !edit-mode true))}
             "Löschen"]
            (when (> index 1)
              [mui/icon-button {:onClick #(>swap-answerOption-index-upwards option-uuid index answerOptions reload-fn)
                                } [arrow-upward]])
            (when (< index (count answerOptions))
              [mui/icon-button {:onClick #(>swap-answerOption-index-downwards option-uuid index answerOptions reload-fn)
                                } [arrow-downward]])
            ]]
          ;edit mode
          [mui/card {:style {:marginBottom "5px"}}

           [mui/card-header {:subheader (str "Antwortoption " (:questionnaireAnswerOption-points answerOption) " Punkte")}]
           [mui/card-content
            [mui/grid {:container true :direction "row" :justify "flex-start" :alignItems "flex-start" :spacing 3}

             [mui/grid {:container false :item true :md 12 :xs 12}
              [mui/select
               {:style    {:backgroundColor (if (changed? :questionnaireAnswerOption-type) "#ffd6d2" "#ffffff") :width "300px"}
                :value    (or (:questionnaireAnswerOption-type @!data) (:questionnaireAnswerOption-type answerOption))
                :onChange (fn [e] (change-fn :questionnaireAnswerOption-type (h/event-value e)))
                :label    "Antwort Option Typ"}
               [mui/menu-item {:value "image" :key "image"} "Bild"]
               [mui/menu-item {:value "radio" :key "radio"} "Einfach-Auswahl"]
               [mui/menu-item {:value "checkbox" :key "checkbox"} "Multi-Auswahl"]
               [mui/menu-item {:value "decimal" :key "decimal"} "Dezimalzahl"]
               [mui/menu-item {:value "numeric" :key "numeric"} "Ganzahl"]
               [mui/menu-item {:value "text" :key "text"} "Text"]
               ]]

             (when (some #(= % (:questionnaireAnswerOption-type answerOption)) ["checkbox" "radioOption"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :questionnaireAnswerOption-text) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:questionnaireAnswerOption-text answerOption))
                                 :onChange     (fn [e] (change-fn :questionnaireAnswerOption-text (h/event-value e)))
                                 :label        "Antwort Text"}]])

             (when (some #(= % (:questionnaireAnswerOption-type answerOption)) ["checkbox" "radioOption"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :questionnaireAnswerOption-textDynamic) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:questionnaireAnswerOption-textDynamic answerOption))
                                 :onChange     (fn [e] (change-fn :questionnaireAnswerOption-textDynamic (h/event-value e)))
                                 :label        "Antwort Text mit Formel"}]])

             (when (some #(= % (:questionnaireAnswerOption-type answerOption)) ["text" "decimal" "number" "image"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :questionnaireAnswerOption-hint) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:questionnaireAnswerOption-hint answerOption))
                                 :onChange     (fn [e] (change-fn :questionnaireAnswerOption-hint (h/event-value e)))
                                 :label        "Hinweis"}]])

             (when (some #(= % (:questionnaireAnswerOption-type answerOption)) ["radioOption"])
               [mui/grid {:container false :item true :md 9 :xs 12}
                [mui/text-field {
                                 :style        {:backgroundColor (if (changed? :questionnaireAnswerOption-radio-group-name) "#ffd6d2" "#ffffff")}
                                 :fullWidth    true
                                 :multiline    true
                                 :defaultValue (str (:questionnaireAnswerOption-radio-group-name answerOption))
                                 :onChange     (fn [e] (change-fn :questionnaireAnswerOption-radio-group-name (h/event-value e)))
                                 :label        "Radio-Gruppe"}]])



             [mui/grid {:container false :item true :md 3 :xs 12}
              [mui/text-field {
                               :style        {:backgroundColor (if (changed? :questionnaireAnswerOption-points) "#ffd6d2" "#ffffff")}
                               :fullWidth    true
                               :defaultValue (str (:questionnaireAnswerOption-points answerOption))
                               :onChange     (fn [e] (change-fn :questionnaireAnswerOption-points (h/event-value e)))
                               :label        "Antwort Punkte"}]
              ]]
            ]
           [mui/card-actions
            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   #(reset! !edit-mode false)} "Abbrechen"]
            (when has-changes? [mui/button {:startIcon (r/as-element [save])
                                            :color     "primary"
                                            :onClick   #(d-questionnaire/>answerOption-save option-uuid @!data reload-fn)}
                                "Speichern"])
            ]]

          )))))

(defn get-answers [!question disabled reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !addOptionPopupShow (r/cursor !st [:addOptionPopupShow])
        ]
    (fn []
      [mui/card-content
       [create-with-name-modal/modal !addOptionPopupShow
        (str "Bitte gib einen Namen für die neue Antwort Option ein -" (get-answerOption-max-index @!question))
        "Anlegen"
        (fn [name]
          (log/debug "Create with Name: " @!question name)
          (d-questionnaire/>answerOption-add-new (:questionnaireQuestion-uuid @!question) name (inc (get-answerOption-max-index @!question)) reload-fn)
          )
        ]
       (doall (for [answerOption (sort-by :questionnaireAnswerOption-index (filter #(not= (:questionnaireAnswerOption-type %) "radioOption") (clojure.walk/keywordize-keys (:questionnaireQuestion-AnswerOption @!question))))]
                ^{:key (str "answerOption-" (:questionnaireAnswerOption-uuid answerOption))}
                [(answer-card answerOption (:questionnaireQuestion-AnswerOption @!question) reload-fn)]))
       [mui/card-actions
        [mui/button {:startIcon (r/as-element [add])
                     :onClick   #(reset! !addOptionPopupShow true)}
         "Neue Antwort hinzufügen"]]
       ])))

(defn question-form [!open-question reload-fn]
  (let [!question (r/cursor vstate/app-state [:edit-questionnaire :questions @!open-question])]
    [mui/card
     [mui/card-actions
      [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                   :onClick   #(reset! !open-question nil)} "Zurück"]
      [mui/button {:startIcon (r/as-element [refresh])
                   :onClick   reload-fn} "Neu laden"]]

     [get-header !question false reload-fn]
     [mui/card {:style {}}
      [mui/card-header {:title "Bild"}]
      [get-image !question reload-fn]
      [mui/divider]


      [get-base !question false reload-fn]

      [mui/divider]
      [get-info !question false reload-fn]
      [mui/divider]
      [(get-answers !question false reload-fn)]
      ]
     [mui/card-actions
      [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                   :onClick   #(reset! !open-question nil)} "Zurück"]]

     ;[:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!question)) "," ",\n")]
     ]))